import {Service} from './';
import {AppStorage} from './UserStorage';

export class ApplicationConfigurationService extends Service {

  static entity: string = 'abp/application-configuration';

  static get(): Promise<any> {
    return this.axios.get(`${this.entity}`).then(res => res.data);
  }

}

export function storeApplicationLocalization(response: any): void {
  const localization = response?.localization?.values?.MInvoice;
  if (localization && typeof localization === 'object') {
    AppStorage.set('localization', JSON.stringify(localization));
  }
}
